import React from "react";
import { observer, inject } from "mobx-react";
import CollapseFiltersContainer from "Containers/CollapseFiltersContainer";
import { SelectField, SelectFieldItemSort } from "ComponentsUI/Selectfield";
import { FiltersLayout, FiltersItem } from "ComponentsUI/Filters";
import FiltersLoadParams from "HOC/FiltersLoadParams";
import { withRouter, Link } from "react-router-dom";
import orderBy from "lodash/orderBy";

var Routes = require("Configs/routes");
import { generateUrl } from "Services/withDefaultParams";
import OrientationChanger from "ComponentsUI/OrientationChanger";
import { SortPanel } from "ComponentsUI/Sort";
import Button from "ComponentsUI/Button";
import queryString from "query-string";

@withRouter
@inject("ApplicationModel")
@observer
export default class Filters extends FiltersLoadParams {
	constructor(props) {
		super(props);
		let text = this.props.ApplicationModel.text;
		this.state = {
			sort: [
				{
					id: 1,
					key: "",
					name: text.SORT_BY_DATE_1,
					down: true,
				},
				{
					id: 2,
					key: "date",
					name: text.SORT_BY_DATE_2,
					up: true,
				},
			],
		};
	}

	componentWillUnmount() {
		let {
			ApplicationModel: { filtersModel },
		} = this.props;
		filtersModel.reset();
	}

	onSort(sort) {
		const {
			location: { search },
			history,
		} = this.props;

		let reviewsUrl = generateUrl(Routes.Reviews.route, {
			regionUrl: this.props.match.params.regionUrl,
			page: this.props.match.params.page,
		});

		const getParams = queryString.parse(search);

		let urlArr = [];

		let activeSort = sort[0];

		if (!!activeSort.key) {
			getParams.sort = activeSort.key;
		} else {
			delete getParams.sort;
		}

		for (let key in getParams) {
			if (getParams[key]) {
				urlArr.push(`${key}=${getParams[key]}`);
			}
		}

		this.props.history.push({
			pathname: reviewsUrl,
			search: `?${urlArr.join("&")}`,
		});
	}

	onFilterHandler(filter) {
		const {
			match: { params },
			location: { search },
			history,
		} = this.props;
		const getParams = queryString.parse(search);
		let filterArr = [];
		let selectedProviders = [];
		let selectedRating = [];
		let selectedServices = [];
		if (filter.providers) {
			filter.providers.map((item) => {
				selectedProviders.push(item.id);
			});
			getParams.providers = selectedProviders.join(",");
		}

		if (filter.rating) {
			filter.rating.map((item) => {
				selectedRating.push(item.id);
			});
			getParams.rating = selectedRating.join(",");
		}

		if (filter.service) {
			filter.service.map((item) => {
				selectedServices.push(item.id);
			});
			getParams.service = selectedServices.join(",");
		}
		for (let key in getParams) {
			if (getParams[key]) {
				filterArr.push(`${key}=${getParams[key]}`);
			}
		}

		const reviewsUrl = generateUrl(Routes.Reviews.route, {
			regionUrl: params.regionUrl,
		});
		history.push({
			pathname: reviewsUrl,
			search: filterArr.length ? `?${filterArr.join("&")}` : "",
		});
	}

	onResetFilters() {
		this.onFilterHandler({
			rating: [],
			service: [],
			providers: [],
		});
	}

	render() {
		let {
			ApplicationModel: { ratesModel, text },
			filters,
		} = this.props;

		let providers = filters?.providers || [];
		let services = filters?.services || [];
		let rating = filters?.rating || [];

		let ratingFilter = [];

		for (const r of rating) {
			switch (r) {
				case "positive":
					ratingFilter.push({
						id: "positive",
						name: text.REVIEW_POSITIVE,
						sort: 1,
					});
					break;
				case "neutral":
					ratingFilter.push({
						id: "neutral",
						name: text.REVIEW_NEUTRAL,
						sort: 2,
					});
					break;
				case "negative":
					ratingFilter.push({
						id: "negative",
						name: text.REVIEW_NEGATIVE,
						sort: 3,
					});
					break;
				// case "without":
				//     ratingFilter.push({
				//         id: "without",
				//         name: text.REVIEW_WITHOUT,
				//         sort: 4
				//     });
				//     break;
			}
		}

		ratingFilter = ratingFilter.sort((a, b) => a.sort - b.sort);

		let sortedProviders = orderBy(providers, "name", "asc");

		let providersFinded = this.providersInitFromGetParams(providers);
		let emotionsFinded = this.emotionReviewsInitFromGetParams(ratingFilter);
		let servicesFinded = this.servicesReviewsInitFromGetParams(services);
		let sortFinded = this.getSortFromParams(this.state.sort);

		let feedbackUrl = generateUrl(Routes.AddReview.route, {
			regionUrl: this.props.match.params.regionUrl,
		});

		let button = (
			<Button
				typeText="big"
				fullWidth={true}
				component={<Link to={!!feedbackUrl ? feedbackUrl : "/"} />}
				size={"middle"}
				status={"tertiaryAccent"}
				transparent={true}
				datatest="main_allreviews_button"
			>
				{text.ratingLeaveReview}
			</Button>
		);

		/*let orientationChanger = (
            <OrientationChanger
                onChange={flat => ratesModel.setReviewsOrientation(flat)}
                datatest="reviews_view"
                flat={ratesModel.reviewsOrientation}
            />
        );*/

		let mobileButtonForSort = (
			<Button
				typeText="big"
				component={<Link to={!!feedbackUrl ? feedbackUrl : "/"} />}
				size={"middle"}
				status={"tertiaryAccent"}
				transparent={true}
				datatest="main_allreviews_button"
			>
				{text.ratingLeaveReview}
			</Button>
		);

		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;

		let sort = (
			<SelectField
				multiselect={false}
				windowSizes={windowSizes}
				items={this.state.sort}
				onItemSelect={(items) => this.onSort(items)}
				text={text}
				findItems={sortFinded}
				placeholder={text.SORT_BY}
				activePlaceHolder={text.SORT_BY}
				onlyInputDisabled={true}
				withoutClose={true}
				whiteInput={true}
				inputName="sort_reviews"
			/>
		);

		return (
			<React.Fragment>
				<FiltersLayout mobileButton={mobileButtonForSort}>
					<CollapseFiltersContainer
						resetFiltersHandler={() => this.onResetFilters()}
						showResetButtonAfterFilterApply
					>
						<FiltersItem>
							<SelectField
								multiselect={true}
								windowSizes={windowSizes}
								isFixedList={windowSizes.xs}
								items={sortedProviders}
								onItemSelect={(items) =>
									this.onFilterHandler({
										providers: items,
									})
								}
								text={text}
								title={text.filtersProvider}
								findItems={providersFinded}
								activePlaceHolder={text.CHOOSE_A_PROVIDERS}
								datatest="reviews_input_filter_provider"
								whiteInput={true}
								onFocus={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.setFocus();
								}}
								onBlur={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.removeFocus();
								}}
								inputName="change_providers"
							/>
						</FiltersItem>
						<FiltersItem>
							<SelectField
								equalBy="value"
								multiselect={false}
								windowSizes={windowSizes}
								isFixedList={windowSizes.xs}
								onlyInputDisabled={true}
								title={text.REVIEW_SINGLE}
								items={ratingFilter}
								onItemSelect={(items) =>
									this.onFilterHandler({
										rating: items,
									})
								}
								text={text}
								activePlaceHolder={text.CHOOSE_A_VALUE}
								findItems={emotionsFinded}
								datatest="reviews_input-filter_reviews"
								whiteInput={true}
								onFocus={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.setFocus();
								}}
								onBlur={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.removeFocus();
								}}
								inputName="change_review"
							/>
						</FiltersItem>
						<FiltersItem>
							<SelectField
								equalBy="value"
								multiselect={false}
								windowSizes={windowSizes}
								isFixedList={windowSizes.xs}
								activePlaceHolder={text.CHOOSE_A_SERVICE}
								title={text.FILTERS_SERVICE}
								items={services}
								onlyInputDisabled={true}
								onItemSelect={(items) =>
									this.onFilterHandler({
										service: items,
									})
								}
								text={text}
								findItems={servicesFinded}
								datatest="reviews_input_filter_service"
								whiteInput={true}
								onFocus={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.setFocus();
								}}
								onBlur={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.removeFocus();
								}}
								inputName="change_services"
							/>
						</FiltersItem>
					</CollapseFiltersContainer>
				</FiltersLayout>
				<SortPanel
					sort={sort}
					button={button}
					// orientationChanger={orientationChanger}
					isButtonHide={true}
					whiteInput={true}
				/>
			</React.Fragment>
		);
	}
}
